import React from 'react';

import './RankWithDelta.styl';
import UpArrow from 'material-ui/svg-icons/navigation/arrow-drop-up';
import DownArrow from 'material-ui/svg-icons/navigation/arrow-drop-down';
import theme from 'styles/theme';

export default class RankWithDelta extends React.PureComponent {
  render() {
    const {rank} = this.props;
    return (
      <div className="rank-with-delta">
        <span className="rank-with-delta-left">{rank}</span>
        {this.renderDelta()}
      </div>
    );
  }

  renderDelta() {
    const {delta, useColor} = this.props;
    const useColorClass = useColor ? 'use-color' : '';
    if (delta > 0) {
      return (
        <span className="rank-with-delta-right">
          <span className="rank-with-delta-right-top">
            <UpArrow className={'up-arrow'} color={theme.palette.topRank} />
          </span>
          <span className={`rank-with-delta-right-bottom ${useColorClass} plus`}>+{delta}</span>
        </span>
      );
    }
    if (delta < 0) {
      return (
        <span className="rank-with-delta-right">
          <span className="rank-with-delta-right-top">
            <DownArrow className={'down-arrow'} color={theme.palette.bottomRank} />
          </span>
          <span className={`rank-with-delta-right-bottom ${useColorClass} minus`}>{delta}</span>
        </span>
      );
    }
    return null;
  }
}
